const primaryMain = '#000000';
const primaryMainOpacity = 'rgba(0, 0, 0, 0.9)';
const secondaryMain = '#FED046';
const secondaryMainOpacity = 'rgba(254, 208, 70, 0.5)';
const secondaryLight = '#FED046';
const tertiaryMain = '#535353';

export const palette = {
  primaryMain,
  primaryMainOpacity,
  primaryText: primaryMain,
  secondaryMain,
  secondaryMainOpacity,
  secondaryLight,
  secondaryText: secondaryMain,
  tertiaryMain,
  formNavBar: {
    currentStepButtonTextColor: tertiaryMain
  }
};
